import React from 'react';
import { useTranslation } from 'react-i18next';
import CargomaticCard from 'components/v2/card';
import LabelValue from 'components/ui/tailwind/label-value';
import EditButton from '../../../v2/buttons/EditButton';
import 'utils/selectize';
const ConsigneeAccountCard = ({ consignee, onEditAccount }) => {
    const { t } = useTranslation();
    return (React.createElement(CargomaticCard, { className: "mb-6", header: () => (React.createElement("header", { onClick: () => onEditAccount(), className: "flex items-center justify-between" },
            React.createElement("h3", { className: "my-0" }, t('ACCOUNT_DETAILS')),
            React.createElement(EditButton, null))) },
        React.createElement(LabelValue, { value: `${consignee.first_name} ${consignee.last_name}`, icon: "user" }),
        React.createElement(LabelValue, { value: consignee.username, icon: "lock" }),
        React.createElement(LabelValue, { value: consignee.phone, icon: "phone" }),
        React.createElement(LabelValue, { value: consignee.email, icon: "envelope" })));
};
export default ConsigneeAccountCard;
